import { render, staticRenderFns } from "./BlockContentText.vue?vue&type=template&id=77ca1828"
import script from "./BlockContentText.vue?vue&type=script&lang=js"
export * from "./BlockContentText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports